/* eslint-disable no-tabs */
export default class UseCaseFileModel {
  constructor() {
    // 圖檔唯一值
    this.imageId = '';
    this.caseId = '';
    /*
      1	LDR23	申請人申請書	string	必要
      2	LDR1	申請人身分證正面	string	必要
      3	LDR2	申請人身分證反面	string	必要
      4	LDR3	申請人身撥款帳戶存摺封面	string	必要
      5	LDR24	申請人薪轉存摺封面	string
      6	LDR14	申請人薪轉存摺內頁	string
      7	LDR19	申請人勞保證明	string
      8	LDR4	申請人機車行照	string
      9	LDR5	申請人財力證明	string
      10	LDR10	申請人個人JCIC	string
      11	LDR9	申請人貸款繳息紀錄	string
      12	LDR8	申請人信用卡帳單	string
      13	LDR11	申請人地價/房屋稅單或謄本	string
      14	LDR7	申請人專業證照	string
      15	LDR6	申請人在職證明	string
      16	LDR25	申請人財力證明	string
      17	GRT1	保證人身分證正面	string
      18	GRT2	保證人身分證反面	string
      19	GRT15	保證人薪轉存摺封面	string
      20	GRT7	保證人薪轉存摺內頁	string
      21	GRT11	保證人財力證明	string
      22	GRT16	保證人其它資料	string
     */
    this.code = '';
    // base64 image
    this.data = '';
    // 檔案類型
    this.type = '';
    // 檔案大小
    this.size = '';
    // 檔案名稱
    this.name = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/UseCaseFileModel.js